// React things
import { useEffect, useRef, useState } from 'react';

// Styles
import style from './VoucherSection.module.css'

// Stores
import useSourceStore from '../../Store/SourceStore.js'
import useApplicationSettings from '../../Store/ApplicationSettings.js';

// Components
import RiveArtboard from '../../ComponentsWrappers/RiveArtboard.jsx'

export default function VoucherSection(props){

    const voucher = useSourceStore((state)=> state.voucher)
    const localization = useApplicationSettings((state)=> state.localization)

    useEffect(()=>{
        
    }, [])

    return(
        <RiveArtboard artboard={localization["rive_voucher 2"]} stateMachines={'State Machine 1'} setLoading={props.setLoading}/>
    )
}